import React from 'react';

import { Route, Routes } from 'react-router-dom';

import ErrorPage from '@/components/errors/ErrorPage';

import InviteEmailCompletePage from './InviteEmailCompletePage';
import InviteEmailConfirmPage from './InviteEmailConfirmPage';
import InviteEmailErrorPage from './InviteEmailErrorPage';
import InviteEmailInputPage from './InviteEmailInputPage';
import InviteInquiryPage from './InviteInquiryPage';
import InviteLimitErrorPage from './InviteLimitErrorPage';

const InviteRoute: React.FC = () => (
  <Routes>
    <Route path=":code/" element={<InviteEmailInputPage />} />
    <Route path=":code/confirm" element={<InviteEmailConfirmPage />} />
    <Route path=":code/email-error" element={<InviteEmailErrorPage />} />
    <Route path="inquiry" element={<InviteInquiryPage />} />
    <Route path="limit-error" element={<InviteLimitErrorPage />} />
    <Route path="complete" element={<InviteEmailCompletePage />} />
    <Route path="*" element={<ErrorPage type="not_found" />} />
  </Routes>
);

export default InviteRoute;
